import './errorText.scss';

import React from 'react';

type IErrorTextProps = {
  children?: string;
  viewPlacehodler?: boolean;
  renderText?: (text: string) => React.ReactNode;
  'data-testid'?: string;
};

const ErrorText: React.FC<IErrorTextProps> = ({
  children,
  renderText,
  viewPlacehodler = false,
  'data-testid': dataTestId,
}) => {
  if (children) {
    return (
      <span className="mm-error-text" data-testid={dataTestId}>
        {renderText ? renderText(children) : children}
      </span>
    );
  }

  if (!children && viewPlacehodler)
    return (
      <span className="mm-error-text__placeholder" data-testid={dataTestId}>
        {renderText ? renderText('-') : '-'}
      </span>
    );

  return null;
};

export { ErrorText };
